import type { ComponentProps } from 'vue-component-type-helpers';
import type { z } from 'zod';

import KUICoreInputCombobox from '~kui/components/KUI/Core/Input/Combobox/KUICoreInputCombobox.vue';
import KUICoreInputDatePickerV2 from '~kui/components/KUI/Core/Input/DatePicker/V2/KUICoreInputDatePickerV2.vue';
import KUICoreInputCheckbox from '~kui/components/KUI/Core/Input/KUICoreInputCheckbox.vue';
import KUICoreInputText from '~kui/components/KUI/Core/Input/Text/KUICoreInputText.vue';
import KUICoreInputTextDeprecated from '~kui/components/KUI/Core/Input/Text/KUICoreInputTextDeprecated.vue';
import KUICorePinCode from '~kui/components/KUI/Core/PinCode/KUICorePinCode.vue';
import KUISchoolsClassYearSelect from '~kui/components/KUI/Schools/ClassYearSelect/KUISchoolsClassYearSelect.vue';

type FormPropsType<T> = Omit<T, 'id'>;

export const allowedComponents = <const>{
  text: {
    component: KUICoreInputText,
    options: <FormPropsType<ComponentProps<typeof KUICoreInputText>>>{},
  },
  textDeprecated: {
    component: KUICoreInputTextDeprecated,
    options: <FormPropsType<ComponentProps<typeof KUICoreInputTextDeprecated>>>{},
  },
  select: {
    component: KUICoreInputCombobox,
    options: <FormPropsType<ComponentProps<typeof KUICoreInputCombobox>>>{},
  },
  checkbox: {
    component: KUICoreInputCheckbox,
    options: <FormPropsType<ComponentProps<typeof KUICoreInputCheckbox>>>{},
  },
  pincode: {
    component: KUICorePinCode,
    options: <FormPropsType<ComponentProps<typeof KUICorePinCode>>>{},
  },
  date: {
    component: KUICoreInputDatePickerV2,
    options: <FormPropsType<ComponentProps<typeof KUICoreInputDatePickerV2>>>{},
  },
  classYear: {
    component: KUISchoolsClassYearSelect,
    options: <FormPropsType<ComponentProps<typeof KUISchoolsClassYearSelect>>>{},
  },
};

export interface FormFieldConfig<T extends z.ZodTypeAny = z.ZodTypeAny, C extends Component = Component> {
  initialValue: unknown;
  component: C;
  props: ComponentProps<C>;
  schema: T;
  hint?: string;
  validationMessage?: string;
  wrapperClass?: string;
}

export type FieldsConfig = Record<string, FormFieldConfig<any, any>>;

export interface FormConfig<T extends z.ZodRawShape = z.ZodRawShape> {
  schema: z.ZodObject<T>;
  fields: FieldsConfig;
  submitButtonText: string | null;
}
